import AirportIcon from '../airports/icon';
import DesignSystemButton from '../design-system/button';
import CloseIcon from '@/assets/icons/close';
import {ToastActionType} from '@/redux/slice/toastSlice';
import classNames from 'classnames';
import {memo, useEffect} from 'react';

type Props = {
  visible: boolean;
  onClose: () => void;
  onDismiss: () => void;
  actionType: ToastActionType;
  title: string;
  message: string;
  actionText: string;
  onPress: () => void;
  entity: any;
};

const Toast = ({
  title,
  message,
  actionText,
  actionType,
  onPress,
  onClose,
  onDismiss,
  visible,
  entity
}: Props) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 30 * 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={classNames(
        'rounded-[12px] flex flex-col  backdrop-blur-[4px] px-2xl bg-[#0D1B164D] w-[280px] h-[130px] app-toast-in mt-md py-xl',
        {
          'app-toast-out': !visible,
          'opacity-1': visible
        }
      )}
    >
      <div className="h-full">
        <div className="flex items-center justify-between">
          {actionType === ToastActionType.FLIGHT && (
            <div className="w-full flex items-center text-[#f1f1f1]">
              {entity?.flight_number}&nbsp;&nbsp;&nbsp;&nbsp;
              {entity?.dep}&nbsp;
              <svg
                width="14"
                height="13"
                viewBox="0 0 14 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.33073 13.0026H5.66406L8.9974 7.66927H12.6641C13.2174 7.66927 13.6641 7.2226 13.6641 6.66927C13.6641 6.11594 13.2174 5.66927 12.6641 5.66927H8.9974L5.66406 0.335938L4.33073 0.335938L5.9974 5.66927H2.33073L1.33073 4.33594H0.330729L0.997396 6.66927L0.330729 9.0026H1.33073L2.33073 7.66927H5.9974L4.33073 13.0026Z"
                  fill="#AAAAAA"
                />
              </svg>
              &nbsp;
              {entity?.dest}&nbsp;&nbsp;&nbsp;&nbsp;
              <div className="rounded-xs px-xs border-[0.5px] border-[#2d2d2d]">
                <p className="text-xs font-medium text-left text-[#cecfd2]">
                  {entity?.type}
                </p>
              </div>
            </div>
          )}
          {actionType === ToastActionType.AIRPORT && (
            <div className="flex gap-x-[4px] items-center">
              <p className="text-xs text-left text-[#f1f1f1]">{entity?.iata}</p>
              <AirportIcon airport={entity?.airport} size={14} />
              <div className="rounded-xs px-xs border-[0.5px] border-[#2d2d2d]">
                <p className="text-xs font-medium text-left text-[#cecfd2]">
                  {entity?.airport}
                </p>
              </div>
            </div>
          )}
          {actionType === ToastActionType.CHAT && (
            <p className="text-[#CECFD2] text-sm leading-sm font-[600]">
              {entity?.flight_number}
            </p>
          )}
          {[ToastActionType.OPS, ToastActionType.ETL].includes(actionType) && (
            <p className="text-[#CECFD2] text-sm leading-sm font-[600]">
              {title}
            </p>
          )}
          <div
            className="cursor-pointer hover:opacity-80"
            onClick={() => onDismiss()}
          >
            <CloseIcon color="#CECFD2" width={16} height={16} />
          </div>
        </div>

        <div className="mt-xs text-[#F1F1F1] text-sm leading-sm line-clamp-2 whitespace-pre-line">
          {message}
        </div>
      </div>
      <div className="flex items-center">
        <DesignSystemButton
          text={actionText}
          onPress={onPress}
          variant="primary"
          size="small"
        />
        <DesignSystemButton
          text="Dismiss"
          onPress={() => onDismiss()}
          variant="tertiary"
          size="small"
        />
      </div>
    </div>
  );
};

export default memo(Toast);
